type AppliedCouponMatch = {
  appliedCouponCode?: string | null;
  couponCodeApplied?: boolean;
  promotionCouponCode?: string | null;
};

function codesMatch(left: string, right: string) {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}

export function isPromotionCouponApplied({
  appliedCouponCode,
  couponCodeApplied,
  promotionCouponCode,
}: AppliedCouponMatch): boolean {
  return Boolean(
    couponCodeApplied &&
      appliedCouponCode?.trim() &&
      promotionCouponCode?.trim() &&
      codesMatch(appliedCouponCode, promotionCouponCode)
  );
}

/** True when a coupon is applied and it is not the sale code the timer is counting toward. */
export function hasDifferentAppliedCoupon(match: AppliedCouponMatch): boolean {
  if (!match.couponCodeApplied || !match.appliedCouponCode?.trim()) {
    return false;
  }

  return !isPromotionCouponApplied(match);
}
